import { useState } from "react";
import { errorMessage } from "../../services";
import { paySite, setSiteStatus, updateSite } from "../../services/sites";
import { payPurchase } from "../../utils/razorpayCheckout";
import { money } from "../../utils/format";

// Enable / disable and "Pay now" for a website row. `reload` refreshes whatever list is on screen.
export default function useSiteActions({ notify, reload }) {
  const [payTarget, setPayTarget] = useState(null);

  const toggle = async (site) => {
    try {
      const { data } = await setSiteStatus(site.id, { active: !site.enabled });
      notify(data.message);
      reload();
    } catch (err) {
      notify(errorMessage(err), "error");
    }
  };

  const linkDomain = async (site) => {
    if (!site.requestedDomain) return;
    if (!window.confirm(`Link ${site.subdomain} to main domain "${site.requestedDomain}"?`)) return;
    try {
      const { data } = await updateSite(site.id, { domain: site.requestedDomain });
      notify(data.message || `Domain linked successfully: ${site.requestedDomain}`);
      reload();
    } catch (err) {
      notify(errorMessage(err), "error");
    }
  };

  // Returns true when the request went through, so the dialog can close
  const pay = async (site, payload) => {
    try {
      const { data, status } = await paySite(site.id, payload);
      if (status === 202 && data.checkout) {
        // Paid in Razorpay on Ownezzy's account; the server activates the plan when Razorpay confirms it
        const outcome = await payPurchase(data.checkout);
        if (outcome === "paid") notify(`Payment of ${money(data.payment.amount)} received. Your plan is active.`);
        else if (outcome === "pending") notify("Payment received. Your plan activates in a minute.", "warn");
        else notify("Payment not completed. Choose Pay now again whenever you are ready.", "warn");
      } else if (status === 202) {
        // Online payment is not set up on the server: the plan is NOT active until Ownezzy confirms the payment
        notify(`${data.message} (${money(data.payment.amount)})`, "warn");
      } else {
        notify(data.message);
      }
      reload();
      return true;
    } catch (err) {
      notify(errorMessage(err), "error");
      return false;
    }
  };

  return { toggle, pay, linkDomain, payTarget, openPay: setPayTarget, closePay: () => setPayTarget(null) };
}
